export default "__VITE_ASSET__CLDKOlb9__"